import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from '../../../services/app/breadcrumb.service';

// Smart component: lives in the app shell, renders whatever trail the
// current page pushed into BreadcrumbService. Hidden when the trail is empty.
@Component({
  selector: 'cf-breadcrumbs',
  imports: [RouterLink],
  templateUrl: './breadcrumbs.html',
  styleUrl: './breadcrumbs.scss'
})
export class Breadcrumbs {
  readonly crumbs = inject(BreadcrumbService).crumbs;
}
